import type { PersistedContact } from "schemas";
import { apiRequest } from "../apiRequest";

export async function runContactImport(id: string) {
  await apiRequest<PersistedContact[]>({ url: `contactImports/${id}/run`, method: "PUT" });
}
